export default __webpack_public_path__ + "static/media/nanny.c25aa484.svg";